var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneInsight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 166,
    viewBox: "0 0 301 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3310_34805)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3310_34805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 301,
    height: 165
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.282 0.915283H0.5V164.688H300.282V0.915283Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3310_34805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.313 149.188C194.466 147.769 194.54 144.892 194.692 143.473C193.285 143.301 191.863 143.202 190.439 143.177C190.143 141.245 189.166 139.309 187.844 138.029C189.014 137.21 189.909 136.504 191.043 135.7C190.127 134.555 188.711 132.639 186.88 130.766C185.322 131.696 184.844 131.938 183.688 132.859C182.868 131.665 182.575 131.295 180.774 130.446C179.605 129.895 178.631 129.703 176.935 129.695C177.11 128.393 177.073 127.899 177.296 126.234C174.25 126.219 171.343 126.366 169.973 126.14C169.717 127.34 169.774 128.118 169.643 129.616C168.915 129.613 167.553 129.723 166.358 129.979C164.889 130.293 163.79 131 163.096 131.592C162.039 130.619 161.258 130.031 160.405 129.535C157.092 132.041 154.828 133.769 154.924 133.893C155.488 134.617 156.62 135.647 157.551 136.381C156.585 137.297 155.773 138.453 155.578 139.416C155.384 140.378 155.262 140.537 155.248 141.512C153.976 141.409 151.746 141.57 150.276 141.617C150.292 143.707 150.308 145.797 150.323 147.886C150.323 147.95 150.325 148.017 150.366 148.069C150.426 148.145 150.546 148.159 150.652 148.167C152.221 148.276 153.443 148.071 155.012 148.181C155.001 150.026 156.09 151.819 157.21 153.419C156.371 154.235 155.117 155.32 154.23 156.023C156.101 157.483 157.538 159.167 159.409 160.628C160.305 160.032 162 158.831 162.895 158.236C163.686 159.278 166.874 161.106 169.655 160.271C169.691 161.422 169.216 163.886 169.953 164.138C171.671 164.726 175.159 164.063 177.015 164.035C177.531 162.74 176.882 161.52 177.398 160.224C179.257 159.852 181.03 158.787 182.909 157.296C183.597 158.094 184.335 158.947 185.191 159.696C185.258 159.754 185.337 159.816 185.432 159.811C185.506 159.807 185.568 159.763 185.626 159.721C187.117 158.632 188.576 157.509 190.001 156.354C190.079 156.291 190.163 156.217 190.17 156.124C190.177 156.03 190.101 155.949 190.03 155.878C189.141 155.006 188.252 154.134 187.364 153.262C188.604 152.16 189.458 150.681 189.931 149.118C195.269 149.319 194.275 149.536 194.313 149.189L194.313 149.188ZM181.12 146.332C180.54 150.445 177.629 152.03 175.61 152.446C173.7 152.84 170.819 153.004 168.527 152.059C166.771 151.335 165.776 150.26 164.903 148.74C163.957 147.093 163.384 145.14 164.093 143.378C164.667 141.95 165.958 140.414 167.361 139.523C169.005 138.48 170.911 138.059 172.915 137.883C174.919 137.707 177.506 137.942 178.861 139.58C180.887 141.593 181.427 144.156 181.12 146.331V146.332Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.261 35.7668C199.181 70.4907 187.306 110.036 176.447 144.723H19.5582C19.4593 139.322 20.1726 129.362 21.3894 124.067C27.773 96.2805 36.1911 64.4686 43.1653 36.7441C99.2033 36.7441 145.045 35.7668 208.261 35.7668Z",
    fill: "#CDE1F4",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.838 10.0086C276.435 6.42072 276.895 5.19684 277.491 1.60894C243.441 0.666606 176.22 1.74643 176.22 1.74643L175 9.89783C175 9.89783 240.255 9.98771 275.838 10.0086Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.943 9.78996C172.491 27.8112 165.428 64.155 165.428 64.155L266.613 63.8772L275.838 10.0087C275.838 10.0087 188.678 9.78955 174.943 9.78955L174.943 9.78996Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.686 111.763C256.45 112.435 257.213 113.106 257.977 113.778",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.374 20.0788C288.647 19.4631 289.919 18.8475 291.192 18.2314",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63 31.6519L206.452 18.2314H244.592L242.304 31.6519H204.63Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.677 54.4538L179.499 41.033H217.639L215.351 54.4538H177.677Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.503 54.4538L261.791 41.033H299.932L297.177 54.4538H259.503Z",
    fill: "#CDE1F4",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9864 144.694C50.2972 138.626 45.9722 132.445 42.1459 126.442C39.7921 122.75 37.3529 119.042 34.0231 115.985C32.1722 114.287 29.9999 112.777 27.4487 112.07C26.489 111.804 25.3874 111.669 24.5192 112.117C23.7736 112.502 23.3607 113.237 23.0864 113.958C21.8201 117.284 22.6707 120.929 23.7932 124.296C26.1027 131.222 30.0251 138.35 33.9386 144.724C41.6728 144.724 47.3924 144.694 53.9854 144.694L53.9864 144.694Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6343 144.992C15.541 145.054 11.9354 139.452 9.41034 133.735C8.15109 130.884 7.08453 127.885 7.23429 124.829C7.30288 123.434 7.73678 121.899 9.06695 121.137C10.0547 120.572 11.3307 120.564 12.4869 120.762C14.2547 121.066 15.8937 121.799 17.403 122.664C21.6273 125.085 24.9628 128.563 27.6035 132.342C30.2442 136.12 32.4903 140.439 34.2236 144.713C25.8324 144.998 20.5813 144.824 15.6343 144.992V144.992Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2515 112.206C31.4633 123.032 37.8641 133.775 44.4519 144.428",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80029 121.203C14.7505 129.077 19.7553 136.925 24.8148 144.745",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.655 74.2711C105.829 76.2436 109.278 76.5719 112.398 76.4328C114.417 76.3429 116.452 76.102 118.33 75.4429C120.207 74.7841 121.93 73.6752 122.611 72.2781C124.642 87.4596 119.67 102.603 117.786 117.799C117.542 119.766 117.383 121.883 118.48 123.87C109.943 125.233 101.276 125.967 92.6924 125.576C94.8745 111.76 97.4182 97.9882 100.322 84.2752C100.814 81.9493 101.439 79.4342 103.656 74.2707L103.655 74.2711Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.196 49.8452C122.697 49.4553 122.709 48.7649 122.526 48.1994C122.343 47.6338 122.005 47.1031 121.931 46.5187C121.885 46.1509 121.945 45.7795 121.935 45.4093C121.891 43.9182 120.536 42.5372 118.866 42.2815C118.482 42.2228 118.076 42.2138 117.736 42.0475C117.227 41.7993 116.953 41.2394 116.4 41.079C115.735 40.8857 115.084 41.3593 114.415 41.5407C113.861 41.6909 113.266 41.6371 112.686 41.6396C110.841 41.6482 109.072 42.2408 107.351 42.8253C106.655 43.0613 105.947 43.3038 105.365 43.7134C105.033 43.9474 104.748 44.2318 104.409 44.4588C103.955 44.7629 103.419 44.9554 102.927 45.2094C101.705 45.8394 100.784 46.8273 99.8905 47.7947C99.2462 48.492 98.5818 49.2263 98.3765 50.1066C98.2216 50.7723 98.3453 51.4635 98.2795 52.1407C98.2268 52.6853 98.0523 53.2147 97.9674 53.7561C97.7317 55.2591 98.1941 56.7719 98.6523 58.2346C98.816 58.7579 98.9817 59.2853 99.2607 59.7696C99.451 60.1004 99.6922 60.4066 99.9372 60.7087C101.649 62.8162 103.609 64.7682 105.774 66.5227C105.916 66.6372 106.07 66.7563 106.26 66.7821C106.593 66.8277 106.875 66.5781 107.086 66.3462C108.813 64.4394 110 62.1575 110.514 59.7618C110.922 57.855 110.972 55.7487 112.379 54.2543C114.193 52.3286 117.441 52.2273 120.072 51.2796C120.547 51.1085 121.034 50.751 122.196 49.846L122.196 49.8452Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5187 126.611C95.8128 125.324 113.107 124.038 129.966 123.014C128.781 129.429 128.091 136.162 126.51 144.723H73.917C75.2187 139.399 76.875 132.196 78.5187 126.611Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.175 57.9014C102.964 58.2983 102.618 60.281 103.087 61.2812C103.942 63.1027 105.769 62.9036 106.384 62.6972C106.524 65.5156 106.571 68.3372 106.351 71.1404C105.349 71.4146 104.347 71.6888 103.345 71.9629C103.051 72.0434 102.742 72.132 102.538 72.3339C102.348 72.5211 102.277 72.7772 102.226 73.0239C101.861 74.8227 102.319 76.7768 103.636 78.1899C104.495 79.1117 105.669 79.7696 106.895 80.2765C108.576 80.9709 110.416 81.41 112.272 81.3801C114.891 81.3378 117.435 80.3466 119.388 78.8121C121.342 77.2775 122.722 75.2266 123.538 73.0378C124.07 71.6095 124.084 69.8702 123.663 68.6139C121.712 68.8334 120.063 69.3461 118.592 69.5418C118.491 67.6904 118.44 66.8737 118.679 65.4269C121.357 65.3128 123.503 63.1963 124.144 60.9057C124.784 58.6151 124.23 56.2039 123.505 53.933C123.019 52.4128 122.455 50.907 121.688 49.4795C121.077 48.3443 120.146 47.143 118.73 46.9817C117.37 46.8269 116.172 47.6909 114.917 48.1793C113.207 48.845 111.127 48.8778 109.75 49.9905C108.414 51.0707 108.171 52.836 108.229 54.4317C108.294 56.2183 108.629 57.9974 109.222 59.7073C108.644 59.8969 108.469 59.8628 107.891 60.052C107.241 59.193 106.449 57.1565 104.176 57.9018L104.175 57.9014Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5225 132.059C82.9663 131.424 88.8049 130.628 92.7683 127.284C97.0999 123.63 98.0312 117.939 98.7725 112.7C100.696 99.1054 102.978 85.5249 103.628 71.8373C98.4375 72.5309 93.0833 73.2828 87.6156 73.8332C85.5595 93.2487 80.6041 112.324 77.5225 132.058V132.059Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0937 99.9583C87.819 95.0172 87.5466 89.8779 88.2935 84.8539C89.11 79.3595 91.1209 74.0651 92.5542 68.6692C93.9875 63.2734 94.8366 57.5944 93.3119 52.2182C91.4904 45.7955 86.459 40.4371 80.8882 35.9869C78.198 33.8379 75.3263 31.8301 72.1001 30.3591C68.9335 28.9157 65.4683 28.0123 61.9439 27.5301C49.2865 25.7981 35.5089 29.9791 27.6539 38.8799C24.457 42.5019 22.2814 46.7571 20.7674 51.1454C19.4344 55.0099 18.5923 59.0247 18.5783 63.0633C18.5344 75.8484 27.547 88.3211 40.7251 93.7129C44.9246 95.4313 49.4746 96.4783 53.5043 98.4865C57.534 100.495 61.1447 103.798 61.5086 107.813C71.4095 105.691 81.1504 102.992 89.0927 99.9583H89.0937Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.861 72.35C99.6268 74.7879 98.3918 77.2258 97.1572 79.6641C97.0597 79.8566 96.9599 80.0651 97.0075 80.2716C97.049 80.4526 97.196 80.5983 97.3378 80.7341C98.3852 81.7421 99.4327 82.7505 100.601 83.6818C99.1723 85.7815 97.7442 87.8816 96.3156 89.9814C96.1322 90.251 95.9428 90.5379 95.9404 90.8519C95.9386 91.1326 96.086 91.3953 96.2306 91.646C97.5515 93.9362 98.8723 96.2268 100.193 98.5169",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6394 98.6855C62.9437 94.2349 58.6943 90.1401 53.9918 86.498C46.8846 80.9934 38.2957 75.9653 35.5145 68.0027C34.8515 66.1049 34.5678 64.0306 35.2742 62.1447C35.9806 60.2588 37.8473 58.6233 40.0961 58.453C41.7226 58.3298 43.3014 58.9545 44.6988 59.6965C47.7035 61.2923 50.2784 63.509 52.1568 66.1168C53.0353 67.3366 53.5602 69.2869 52.0999 69.9465C51.2227 70.3425 50.158 69.9518 49.3327 69.4782C44.3055 66.5933 42.3333 60.2371 44.9974 55.5053C45.2764 55.0095 45.6095 54.5211 46.1022 54.1776C46.7363 53.7351 47.5663 53.5788 48.3711 53.5053C54.3361 52.9619 60.4056 56.8445 61.6565 62.0039C61.8165 62.6643 61.8991 63.3817 61.5692 63.9916C61.2394 64.6015 60.3646 65.0242 59.6764 64.7246C59.3769 64.5941 59.1604 64.3548 58.9625 64.118C56.8467 61.587 55.6798 58.4525 55.6831 55.3108C55.6849 53.8024 55.9728 52.242 56.9251 50.9878C58.9187 48.3627 63.4178 47.9141 66.5694 49.4245C69.721 50.9348 71.6493 53.9112 72.6268 56.9488C72.8876 57.7593 73.0915 58.6286 72.8176 59.4359C72.5437 60.2432 71.6386 60.9426 70.6952 60.7952C69.8125 60.6573 69.2633 59.889 68.8831 59.1749C68.0531 57.6145 67.4862 55.9461 67.2072 54.2412C67.0266 53.1388 66.7779 51.4376 67.2035 50.3885C67.6528 49.2792 68.388 47.7241 70.7423 47.209C71.8919 46.9574 73.7811 48.0385 74.5509 48.8306C80.1151 54.5531 79.8823 64.5502 79.6383 72.0778C79.3943 79.605 78.1154 87.2433 80.151 94.5641",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.904 58.76C200.488 55.5756 203.521 52.9501 207.105 49.7656C207.656 49.2764 208.903 48.41 209.513 49.0876C209.947 49.5702 209.188 51.3314 206.185 53.601C209.186 51.0954 210.604 50.0287 213.605 47.523C213.984 47.2062 214.462 46.8647 214.921 46.9895C215.391 47.1171 215.55 47.702 215.38 48.1584C215.209 48.6148 214.81 48.9669 214.426 49.2969C212.227 51.1902 212.257 51.4898 210.059 53.3831C212.857 50.8762 213.045 50.4851 216.142 48.3275C216.655 47.97 217.356 47.6084 217.837 47.9388C218.86 48.8569 216.789 50.4247 215.207 51.6737C214.301 52.389 213.429 53.0609 211.222 54.6923C213.492 53.1401 214.331 52.4001 216.605 50.8532C217.032 50.5626 217.493 50.2606 218.001 50.2318C218.509 50.2031 219.042 50.586 218.94 51.0646C218.876 51.3691 218.593 51.5953 218.33 51.7919C215.895 53.615 215.179 54.4576 212.744 56.2807C214.532 54.9804 214.728 54.8245 216.73 53.8739C217.325 53.5916 218.195 53.3987 218.461 53.9388C218.707 54.4379 218.141 54.9936 217.643 55.342C212.748 58.7711 208.903 60.9903 204.008 64.4194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.904 58.76C200.488 55.5756 203.521 52.9501 207.105 49.7656C207.656 49.2764 208.903 48.41 209.513 49.0876C209.947 49.5702 209.188 51.3314 206.185 53.601C209.186 51.0954 210.604 50.0287 213.605 47.523C213.984 47.2062 214.462 46.8647 214.921 46.9895C215.391 47.1171 215.55 47.702 215.38 48.1584C215.209 48.6148 214.81 48.9669 214.426 49.2969C212.227 51.1902 212.257 51.4898 210.059 53.3831C212.857 50.8762 213.045 50.4851 216.142 48.3275C216.655 47.97 217.356 47.6084 217.837 47.9388C218.86 48.8569 216.789 50.4247 215.207 51.6737C214.301 52.389 213.429 53.0609 211.222 54.6923C213.492 53.1401 214.331 52.4001 216.605 50.8532C217.032 50.5626 217.493 50.2606 218.001 50.2318C218.509 50.2031 219.042 50.586 218.94 51.0646C218.876 51.3691 218.593 51.5953 218.33 51.7919C215.895 53.615 215.179 54.4576 212.744 56.2807C214.532 54.9804 214.728 54.8245 216.73 53.8739C217.325 53.5916 218.195 53.3987 218.461 53.9388C218.707 54.4379 218.141 54.9936 217.643 55.342C212.748 58.7711 208.903 60.9903 204.008 64.4194",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.185 53.601C206.655 54.3845 207.05 55.216 207.192 56.093C207.334 56.9701 207.207 57.9014 206.693 58.6635",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.401 128.887C132.282 113.239 135.163 97.591 138.044 81.9432C146.112 85.2652 154.344 87.8878 162.606 90.3729C167.415 91.8192 172.64 93.2294 177.482 91.8701C181.372 90.778 184.351 88.0688 187.156 85.4581C194.739 78.4008 202.321 71.3436 209.905 64.2864C205.875 60.9213 201.93 57.9379 198.15 54.7994C189.006 61.5673 180.503 68.7559 172.287 76.1891C163.863 73.0079 155.552 70.2584 147.241 67.5094C145.633 66.9775 144.014 66.4427 142.324 66.1669C135.702 65.0863 129.156 68.0664 122.437 68.7653C120.423 88.0515 119.068 97.2167 116.245 116.594C115.933 118.736 116.232 120.94 116.863 123.027C117.493 125.114 118.808 127.118 120.881 128.274C122.954 129.43 126.356 130.903 129.401 128.887V128.887Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68 71.0801C126.081 74.0359 127.482 76.9918 129.056 80.0162C127.805 81.385 126.554 82.7538 125.341 84.1168C125.928 85.2696 126.702 86.3487 127.491 87.2126C125.771 91.3062 123.66 95.2721 121.186 99.0554",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9393 108.745C62.8925 111.427 63.8625 114.142 65.5528 116.527C69.8312 122.562 77.2356 123.238 81.6255 121.821C86.9107 120.114 91.6328 117.452 90.5984 107.623C90.3278 105.049 89.7684 102.474 89.0937 99.9583C79.0496 103.245 70.8941 105.066 61.5096 107.813C61.4751 107.813 61.6421 107.907 61.9398 108.745L61.9393 108.745Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5327 95.3103C82.7458 94.363 83.3514 92.9725 84.1277 91.7199C84.4861 91.142 84.9382 90.5477 85.6417 90.3232C85.7285 90.2953 85.8265 90.2744 85.9114 90.306C85.9977 90.338 86.049 90.4164 86.0882 90.4915C86.9057 92.0585 85.1845 93.9797 85.9613 95.5623",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5327 95.3103C82.7458 94.363 83.3514 92.9725 84.1277 91.7199C84.4861 91.142 84.9382 90.5477 85.6417 90.3232C85.7285 90.2953 85.8265 90.2744 85.9114 90.306C85.9977 90.338 86.049 90.4164 86.0882 90.4915C86.9057 92.0585 85.1845 93.9797 85.9613 95.5623",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2325 97.4375C77.3605 95.8746 82.489 94.3113 87.6169 92.7484C87.7886 92.6958 87.9659 92.6429 88.1474 92.6523C88.6551 92.679 88.9732 93.2015 88.9023 93.6447C88.8314 94.088 88.4955 94.4574 88.1722 94.803C88.8347 94.5694 89.604 95.1132 89.6946 95.7363C89.7851 96.3593 89.3726 96.963 88.8477 97.3886C89.4963 97.5208 90.0351 98.0018 90.176 98.5739C90.3169 99.1461 90.0519 99.7802 89.5233 100.136C90.1378 100.219 90.5922 100.74 90.6767 101.282C90.8792 102.584 89.06 103.039 87.0907 103.651C82.4918 105.08 78.0473 106.198 72.8456 107.813C72.6902 107.862 69.5628 106.374 71.5984 98.4278C71.6759 98.1249 71.731 97.5906 72.233 97.4375H72.2325Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5623 98.0124C49.7821 100.006 48.3348 103.098 47.4455 106.155C46.9552 107.841 46.5992 109.593 46.8572 111.319C47.1152 113.045 48.0618 114.757 49.7167 115.712C51.813 116.922 54.5503 116.713 57.0189 116.327C63.2975 115.346 69.4024 113.51 75.1407 111.04C74.4707 106.396 73.4732 101.789 72.2905 97.2737C67.6626 98.892 63.3604 100.384 58.6859 102.191C57.8998 101.027 53.3793 98.0666 52.5623 98.0124Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3777 104.198C53.7273 103.625 56.4306 103.006 58.6859 102.191",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.121 53.7709L119.29 56.9324C119.389 57.076 119.489 57.2554 119.398 57.4027C119.349 57.4811 119.256 57.5291 119.167 57.5722C118.622 57.8361 118.053 58.0643 117.469 58.2539",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 64.9016C116.239 65.5382 117.514 65.58 119.049 65.3958",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.404 6.31201C115.215 7.37583 115.026 8.43965 114.837 9.50346",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.849854 46.9459C1.74052 47.3379 2.63166 47.7294 3.52233 48.1214",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.846 31.6233C222.594 33.0947 222.634 34.2619 222.382 35.7333C213.591 35.8305 197.425 35.9229 197.425 35.9229C197.425 35.9229 197.143 39.164 196.905 41.1353",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.083 35.7668C239.199 35.7496 246.719 35.9228 246.719 35.9228",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.719 35.9227C245.19 48.4759 240.607 73.4695 240.607 73.4695H260.484",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.583 80.1796L257.405 66.7592H295.079L293.257 80.1796H255.583Z",
    fill: "#CDE1F4",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.628 73.3558L236.146 100.779L255.326 100.768",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.806 106.669L253.094 93.2483H291.235L288.48 106.669H250.806Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.015 47.7434C250.234 47.6416 255.428 47.6531 260.647 47.7434H245.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.015 47.7434C250.234 47.6416 255.428 47.6531 260.647 47.7434",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.853 113.584C212.446 113.696 212.243 114.17 212.441 114.503C212.638 114.836 213.163 114.968 213.546 114.8C213.924 114.634 214.122 114.191 213.941 113.854C213.76 113.517 213.261 113.471 212.853 113.584Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01134 83.4187C2.75193 83.4905 2.62269 83.7926 2.74866 84.0043C2.87463 84.2161 3.20916 84.3007 3.4527 84.1939C3.69392 84.0881 3.81989 83.8053 3.70465 83.5906C3.58941 83.376 3.27168 83.3464 3.01134 83.4187Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.766 23.6523C150.359 23.7647 150.156 24.2388 150.353 24.5716C150.551 24.9045 151.076 25.0367 151.458 24.8692C151.837 24.703 152.034 24.2593 151.853 23.9224C151.672 23.5854 151.174 23.5394 150.766 23.6523Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3310_34805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 164.169,
    fill: "white",
    transform: "translate(0.5 0.915283)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneInsight);
export default __webpack_public_path__ + "static/media/ONEInsight.d0e410f2a18621d96e10071d8c764dfc.svg";
export { ForwardRef as ReactComponent };